export const ImageSources = {
    clinicIcon: '/images/clinic-icon.png',
    clinicIconSvg: '/images/clinic-ico.svg',
    odontiaIcoSrc: '/images/odontia-symbol.png',
    defaultAvatarSrc: '/images/default-avatar.jpg',
    mapMarkerIco: '/images/map-marker.svg',
}
